import { useAuth } from 'app/providers/auth/AuthProvider'
import { useCallback, useEffect, useState } from 'react'
import type { ScheduleCalendarView } from './schedulePreferencesStorage'
import { getScheduleView, setScheduleView } from './scheduleViewStorage'

export const useScheduleViewPreference = () => {
  const { userId } = useAuth()
  const [currentView, setCurrentViewState] = useState<ScheduleCalendarView>(() =>
    getScheduleView(userId),
  )

  useEffect(() => {
    setCurrentViewState(getScheduleView(userId))
  }, [userId])

  const setCurrentView = useCallback(
    (view: ScheduleCalendarView) => {
      setCurrentViewState(setScheduleView(userId, view))
    },
    [userId],
  )

  return { currentView, setCurrentView }
}
